import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { COLORS, STRINGS } from "../../constants";

const PageNotFound = () => {
  return (
    <View style={styles.centerContainer} testID="no-results">
      <Text style={styles.noResultsText}>{STRINGS.pageNotFound}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  centerContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  noResultsText: {
    fontSize: 32,
    color: COLORS.textDark,
    fontWeight: "bold",
    textAlign: "center",
  },
});

export default PageNotFound;
